export const watchlist = [
  { name: "TCS", price: 3350.75, percent: "+1.25%", isDown: false },
  { name: "INFY", price: 1405.2, percent: "-0.85%", isDown: true },
  { name: "RELIANCE", price: 2625.4, percent: "+0.95%", isDown: false },
  { name: "HDFCBANK", price: 1550.0, percent: "-1.10%", isDown: true },
  { name: "ICICIBANK", price: 940.2, percent: "+0.75%", isDown: false },
  { name: "WIPRO", price: 395.6, percent: "-0.60%", isDown: true },
  { name: "HINDUNILVR", price: 2543.1, percent: "+0.25%", isDown: false },
  { name: "ITC", price: 432.5, percent: "+1.50%", isDown: false },
  { name: "SBIN", price: 585.5, percent: "-0.40%", isDown: true },
  { name: "BHARTIARTL", price: 875.2, percent: "+2.10%", isDown: false },
  { name: "KOTAKBANK", price: 1780.0, percent: "-1.25%", isDown: true },
  { name: "L&T", price: 2950.3, percent: "+1.10%", isDown: false },
  { name: "ASIANPAINT", price: 3105.8, percent: "-0.30%", isDown: true },
  { name: "AXISBANK", price: 910.4, percent: "+0.85%", isDown: false },
  { name: "MARUTI", price: 9400.0, percent: "+0.45%", isDown: false },
  { name: "SUNPHARMA", price: 1120.6, percent: "-1.15%", isDown: true },
  { name: "TITAN", price: 3250.0, percent: "+1.75%", isDown: false },
  { name: "ULTRACEMCO", price: 8100.5, percent: "-0.20%", isDown: true },
  { name: "BAJFINANCE", price: 6800.0, percent: "+1.40%", isDown: false },
  { name: "NTPC", price: 245.8, percent: "+0.55%", isDown: false },
  { name: "TATAMOTORS", price: 620.3, percent: "-2.10%", isDown: true },
  { name: "TATASTEEL", price: 118.3, percent: "-0.80%", isDown: true },
  { name: "POWERGRID", price: 255.4, percent: "+0.90%", isDown: false },
  { name: "INDUSINDBK", price: 1420.2, percent: "+1.35%", isDown: false },
  { name: "HCLTECH", price: 1185.2, percent: "-0.50%", isDown: true },
];

export const holdings = [
  {
    name: "TCS",
    qty: 10,
    avg: 3200.5,
    price: 3350.75,
    net: "+4.69%",
    day: "+1.25%",
  },
  {
    name: "INFY",
    qty: 8,
    avg: 1450.0,
    price: 1405.2,
    net: "-3.08%",
    day: "-0.85%",
    isLoss: true,
  },
  {
    name: "RELIANCE",
    qty: 5,
    avg: 2500.0,
    price: 2625.4,
    net: "+5.01%",
    day: "+0.95%",
  },
  {
    name: "HDFCBANK",
    qty: 12,
    avg: 1600.3,
    price: 1550.0,
    net: "-3.14%",
    day: "-1.10%",
    isLoss: true,
  },
  {
    name: "ICICIBANK",
    qty: 7,
    avg: 900.5,
    price: 940.2,
    net: "+4.41%",
    day: "+0.75%",
  },
  {
    name: "WIPRO",
    qty: 15,
    avg: 410.0,
    price: 395.6,
    net: "-3.51%",
    day: "-0.60%",
    isLoss: true,
  },
  {
    name: "LT",
    qty: 4,
    avg: 2800.0,
    price: 2950.3,
    net: "+5.36%",
    day: "+1.10%",
  },
  {
    name: "SBIN",
    qty: 20,
    avg: 600.0,
    price: 585.5,
    net: "-2.42%",
    day: "-0.90%",
    isLoss: true,
  },
  {
    name: "HCLTECH",
    qty: 6,
    avg: 1100.0,
    price: 1185.2,
    net: "+7.74%",
    day: "+1.45%",
  },
  {
    name: "AXISBANK",
    qty: 9,
    avg: 950.0,
    price: 910.4,
    net: "-4.17%",
    day: "-1.20%",
    isLoss: true,
  },
  {
    name: "MARUTI",
    qty: 3,
    avg: 9000.0,
    price: 9400.0,
    net: "+4.44%",
    day: "+0.80%",
  },
  {
    name: "BAJFINANCE",
    qty: 2,
    avg: 7000.0,
    price: 6800.0,
    net: "-2.85%",
    day: "-0.70%",
    isLoss: true,
  },
  {
    name: "ADANIENT",
    qty: 5,
    avg: 2200.0,
    price: 2350.0,
    net: "+6.81%",
    day: "+1.95%",
  },
];
export const positions = [
  {
    product: "CNC",
    name: "EVEREADY",
    qty: 2,
    avg: 316.27,
    price: 312.35,
    net: "+0.58%",
    day: "-1.24%",
    isLoss: true,
  },

  {
    product: "CNC",
    name: "INFY",
    qty: 10,
    avg: 1450.0,
    price: 1420.2,
    net: "-2.05%",
    day: "-0.75%",
    isLoss: true,
  },
];
